export interface MockChipRowProps {
  readonly chips: readonly string[];
}

/**
 * Hàng chip. `flex-wrap` là cách xuống dòng ở mobile — không cần breakpoint nào, và cũng không
 * được thêm: chip dài ngắn khác nhau giữa `vi` và `en`, nên điểm wrap không cố định theo khổ.
 */
export function MockChipRow({ chips }: MockChipRowProps) {
  return (
    <div className="flex flex-wrap gap-2.5">
      {chips.map((chip) => (
        <span
          key={chip}
          className="rounded-pill border border-ink-100 bg-surface px-3.5 py-[7px] text-caption leading-[normal] text-ink-700"
        >
          {chip}
        </span>
      ))}
    </div>
  );
}
